import { Checkbox as FluentCheckBox, ICheckboxProps, ITextFieldProps, useTheme } from "@fluentui/react";
import React from "react";

export interface ICustomCheckboxProps extends ICheckboxProps {
    textFieldProps?: ITextFieldProps;
}

const Checkbox: React.FunctionComponent<ICustomCheckboxProps> = (props) => {
    const theme = useTheme();




    return <FluentCheckBox
        {...props}
        styles={{
            ...props.styles,
            text: {
                ...(props.disabled && { color: theme.semanticColors.bodyText }),
            },
        }}
    />;

}

export default Checkbox;